import { InjectionKey, Ref } from 'vue';

export const MapProvider = Symbol() as InjectionKey<Ref<google.maps.Map | undefined>>;
export const LineProvider = Symbol() as InjectionKey<Ref<GeoJSON.LineString | undefined>>;
export const LineDistancesProvider = Symbol() as InjectionKey<Ref<number[] | undefined>>;
export const LineBoundsProvider = Symbol() as InjectionKey<Ref<google.maps.LatLngBounds | undefined>>;

